<!-- src/components/PushPermissionBanner.vue -->
<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { usePush } from '@/composables/usePush';

const { t } = useI18n();
const { permissionState, requestPermissionAgain, openAppSettings } = usePush();

// Показываем баннер только если разрешение не выдано (и не находится в процессе)
const showBanner = computed(() => {
  return permissionState.value === 'prompt' || permissionState.value === 'denied';
});

const isDenied = computed(() => permissionState.value === 'denied');

async function handleEnable() {
  if (isDenied.value) {
    // Если пользователь ранее нажал "Запретить", системный диалог не появится.
    // Отправляем его сразу в настройки приложения.
    await openAppSettings();
  } else {
    // Первый раз: показываем системный диалог запроса.
    await requestPermissionAgain();
  }
}
</script>

<template>
  <transition name="fade">
    <div v-if="showBanner" class="push-banner">
      <div class="push-banner-content">
        <div class="push-banner-text">
          <span class="icon">🔔</span>
          <span>{{ t('notifications.pushBanner') }}</span>
        </div>
        <button @click="handleEnable" class="push-btn">
          {{ isDenied ? t('notifications.openSettings') : t('notifications.enable') }}
        </button>
      </div>
    </div>
  </transition>
</template>

<style scoped>
.push-banner {
  position: fixed;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  width: 90%;
  max-width: 400px;
  background: #1e293b; /* Темный современный фон */
  color: white;
  padding: 16px 20px;
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  z-index: 9999;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.push-banner-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}

.push-banner-text {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  line-height: 1.4;
}

.icon {
  font-size: 18px;
}

.push-btn {
  background: #3b82f6; /* Акцентный синий цвет */
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
  white-space: nowrap;
  transition: background 0.2s;
}

.push-btn:hover {
  background: #2563eb;
}

/* Анимация появления */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(20px);
}
</style>
